import {tagFrequencies} from "../state/tagFrequencies";
import {TagFrequencyItem} from "./tagFrequencyItem";


export const TagFrequencyView = () => <div>
    {tagFrequencies.value?tagFrequencies.value.map(tag => <TagFrequencyItem key={tag.tag} tag={tag}/>
):null}
</div>